import React from 'react';
import Modal from '../ui/Modal';
import Button from '../ui/Button';

const ICON_STYLES = {
  danger: 'bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400',
  warning: 'bg-amber-100 text-amber-600 dark:bg-amber-900/30 dark:text-amber-400',
  info: 'bg-indigo-100 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400',
};

const BUTTON_VARIANT = { danger: 'danger', warning: 'warning', info: 'primary' };

export default function ConfirmModal({
  open,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'danger',
  loading = false,
}) {
  // While the action runs, neither Esc nor the backdrop may dismiss it.
  const close = loading ? undefined : onCancel;

  return (
    <Modal
      open={open}
      onClose={close}
      size="md"
      closeOnBackdrop={!loading}
      footer={(
        <>
          <Button variant="secondary" onClick={onCancel} disabled={loading}>
            {cancelText}
          </Button>
          <Button variant={BUTTON_VARIANT[variant] || 'primary'} onClick={onConfirm} loading={loading}>
            {loading ? 'Processing...' : confirmText}
          </Button>
        </>
      )}
    >
      <div className="flex items-start gap-4">
        <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${ICON_STYLES[variant] || ICON_STYLES.info}`}>
          {variant === 'danger' ? (
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          ) : (
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base font-semibold text-gray-900 dark:text-white">{title}</h3>
          <p className="text-gray-600 dark:text-slate-400 text-sm mt-1">{message}</p>
        </div>
      </div>
    </Modal>
  );
}
